import { createContext, useContext } from "react";

const UI_EN = {
  "Tüm Ürünler": "All Products",
  "Sipariş Vermeye Başla": "Start Your Order",
  "Menüden seç, sepete ekle ve siparişini tamamla.": "Pick from the menu, add to cart and complete your order.",
  "Sepetim": "My Cart",
  "Yükleniyor...": "Loading...",
  "Bu kategoride henüz ürün yok.": "No products in this category yet.",
  "ürün": "items",
  "Sepetiniz boş": "Your cart is empty",
  "Sepete Git": "Go to Cart",
  "Sipariş Vermek İçin Dokunun": "Tap Here to Order",
  "Ekrana dokunarak başlayın": "Touch the screen to start",
  "Hoş geldiniz": "Welcome",
  "sepete eklendi": "added to cart",
  "Menü yüklenemedi": "Menu could not be loaded",
  "Görsel yok": "No image",
  "İNDİRİM": "OFF",
  "Sepete Eklendi": "Added to Cart",
  "Eklendi": "Added",
  "Ekle": "Add",
  "Siparişini özelleştir": "Customize your order",
  "İçecek": "Drink",
  "Lütfen bir içecek seçin": "Please choose a drink",
  "SEÇİLDİ": "SELECTED",
  "ZORUNLU": "REQUIRED",
  "Çıkarılabilir Malzemeler": "Removable Ingredients",
  "Eklenebilir Malzemeler": "Extra Ingredients",
  "Sepete Ekle": "Add to Cart",
  "Çıkarılan": "Without",
  "Eklenen": "Extra",
  "Sipariş Alındı": "Order Received",
  "Ödeme": "Payment",
  "Siparişiniz Alındı!": "Your Order Is Received!",
  "Sipariş numaranız": "Your order number",
  "Fişi Tekrar Yazdır": "Print Receipt Again",
  "Fişiniz yazdırılıyor · 5 saniye içinde ana ekrana dönülecek": "Printing your receipt · returning to the home screen in 5 seconds",
  "Yeni Sipariş": "New Order",
  "Sepetiniz boş. Menüden ürün ekleyin.": "Your cart is empty. Add items from the menu.",
  "Not ekle (örn. soğansız)": "Add a note (e.g. no onions)",
  "Teslimde Kredi Kartı": "Card at Pickup",
  "Teslimde Nakit Ödeme": "Cash at Pickup",
  "Kredi Kartı": "Credit Card",
  "indirim": "off",
  "Kaldır": "Remove",
  "İndirim kodu": "Discount code",
  "Uygula": "Apply",
  "İndirim kodu geçersiz": "Invalid discount code",
  "İndirim kodunun süresi dolmuş": "This discount code has expired",
  "İndirim kodu sadece kioskta geçerli": "Discount codes are only valid at the kiosk",
  "Sepet Tutarı": "Cart Total",
  "İndirim": "Discount",
  "Ara Toplam (KDV hariç)": "Subtotal (excl. VAT)",
  "KDV (%10) dahil": "VAT (10%) included",
  "Toplam (KDV dahil)": "Total (incl. VAT)",
  "Gönderiliyor...": "Sending...",
  "Siparişi Onayla": "Confirm Order",
  "Siparişi Tamamla": "Checkout",
  "Gel-Al": "Take-away",
  "Link": "Online",
  "Sipariş oluşturulamadı": "Order could not be created",
  "Oturum süresi doldu, lütfen yeniden giriş yapın": "Session expired, please sign in again",
  "Şube şu anda kapalı, sipariş alınamıyor": "The branch is closed, orders cannot be taken right now",
  "internet bağlantısı yok veya sunucuya ulaşılamıyor": "no internet connection or the server cannot be reached",
  "hata": "error",
  "Sipariş alındı ama fiş yazdırılamadı": "Order received but the receipt could not be printed",
  "İletişim Bilgisi": "Contact Info",
  "Telefon (10 haneli, zorunlu)": "Phone (10 digits, required)",
  "Ad Soyad (zorunlu)": "Full name (required)",
  "Lütfen ad soyad ve telefon numaranızı girin": "Please enter your name and phone number",
  "Telefon numarası 10 haneli olmalıdır": "Phone number must be 10 digits",
};

export const makeT = (lang, menu = {}) => ({
  lang,
  t: (s) => (lang === "en" && UI_EN[s]) || s,
  m: (s) => (lang === "en" && s && (menu[s] || UI_EN[s])) || s,
});

export const LangContext = createContext({ lang: "tr", menu: {} });

export const buildNote = ({ removals = [], added = [], drink = "" }, t, m) => {
  const parts = [];
  if (removals.length) parts.push(`${t("Çıkarılan")}: ${removals.map(m).join(", ")}`);
  if (added.length) parts.push(`${t("Eklenen")}: ${added.map(m).join(", ")}`);
  if (drink) parts.push(`${t("İçecek")}: ${m(drink)}`);
  return parts.join(" · ");
};

export const useT = () => {
  const { lang, menu } = useContext(LangContext);
  return makeT(lang, menu);
};

export const LangToggle = ({ lang, setLang, className = "" }) => (
  <div data-testid="kiosk-lang-toggle" className={`inline-flex bg-white/95 rounded-full p-1 shadow-lg ${className}`}>
    {[
      ["tr", "Türkçe"],
      ["en", "English"],
    ].map(([code, label]) => (
      <button
        key={code}
        type="button"
        data-testid={`kiosk-lang-${code}`}
        onClick={(e) => {
          e.stopPropagation();
          setLang(code);
        }}
        style={{ touchAction: "manipulation" }}
        className={`px-4 py-2 rounded-full text-sm sm:text-base font-extrabold transition-colors ${
          lang === code ? "bg-[var(--fb-red)] text-white" : "text-[var(--fb-ink)]"
        }`}
      >
        {label}
      </button>
    ))}
  </div>
);
